class ReflowDoubleClick {

    constructor($parse) {

    return {
        restrict: "A",
        scope: {
            dblclickAction: "&reflowDoubleClick"
        },
        link: function($scope, $element, $attributes) {

            var fn = $parse($attributes.doubleClick);
            
            var cb = function() { 
                fn($scope.$parent, {$event:event}); 
            };
            
            $element.dblclick(function(ev){
                $scope.dblclickAction();
                $scope.$apply();
            });
                                            
        }
    }; 

    }

}


angular.module('cpm')
    .directive('reflowDoubleClick', ['$parse', ($parse) => {
        'use strict';
        return new ReflowDoubleClick($parse);
    }]);
